import { defineMessages } from 'react-intl';

/**
 * Global translation messages
 * These messages are used throughout the application for various UI elements
 * including search tabs, video placeholders, breadcrumbs, and skip links
 */
export const registerGlobalMessages = () => {
  defineMessages({
    All: {
      id: 'All',
      defaultMessage: 'All',
    },
    DegreeProgram: {
      id: 'Degree Program Global',
      defaultMessage: 'Degree programmes',
    },
    FHNWNews: {
      id: 'FHNW News Global',
      defaultMessage: 'News',
    },
    FHNWEvent: {
      id: 'FHNW Event Global',
      defaultMessage: 'Events',
    },
    ContinuingEducation: {
      id: 'Continuing Education Global',
      defaultMessage: 'Continuing education programmes',
    },
    Files: {
      id: 'File Global',
      defaultMessage: 'Documents',
    },
    Contact: {
      id: 'Contact Global',
      defaultMessage: 'Persons',
    },
    Page: {
      id: 'Page Global',
      defaultMessage: 'General',
    },
    persons: {
      id: 'Persons',
      defaultMessage: 'Persons',
    },
    video_placeholder: {
      id: 'block.video.placeholder',
      defaultMessage: 'Click to play video',
    },
    breadcrumb_expander: {
      id: 'breadcrumb_expander',
      defaultMessage: 'Show complete path',
    },
    mainView: {
      id: 'skiplink_main-content',
      defaultMessage: 'Skip to main content',
    },
    navigation: {
      id: 'skiplink_navigation',
      defaultMessage: 'Skip to navigation',
    },
    skiplinks_searchbar: {
      id: 'skiplinks_searchbar',
      defaultMessage: 'Skip to searchbar',
    },
    footer: {
      id: 'skiplink_footer',
      defaultMessage: 'Skip to footer',
    },
    image_data: {
      id: 'Image Data',
      defaultMessage: 'Image Data',
    },
    university: {
      id: 'University',
      defaultMessage: 'University',
    },
    field_of_study: {
      id: 'Field of Study',
      defaultMessage: 'Field of Study',
    },
    organizational_unit: {
      id: 'Organizational Unit',
      defaultMessage: 'Organizational Unit',
    },
    topics: {
      id: 'Topics',
      defaultMessage: 'Topics',
    },
    research_areas: {
      id: 'Research Areas',
      defaultMessage: 'Research Areas',
    },
    future_fields: {
      id: 'Future fields',
      defaultMessage: 'Future fields',
    },
    contacts: {
      id: 'Contacts',
      defaultMessage: 'Contacts',
    },
    translations: {
      id: 'Translations',
      defaultMessage: 'Translations',
    },
    dimensions: {
      id: 'Dimensions',
      defaultMessage: 'Dimensions',
    },
    size: {
      id: 'Size',
      defaultMessage: 'Size',
    },
    link: {
      id: 'Redirection',
      defaultMessage: 'Redirection',
    },
  });
};
